import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import {
  STComponent,
  STData,
  STColumn,
  STChange,
  STReq,
  STRes,
  STRequestOptions,
} from '@delon/abc';
import { _HttpClient, ModalHelper } from '@delon/theme';
import { NzMessageService } from 'ng-zorro-antd';
import { ActivatedRoute, Router } from '@angular/router';
import { format } from 'date-fns';
import { DialogService, MessageService } from 'mmmo-mo-common-lib';
import { URLS } from '../../shared/constant/interface';
import { getEndDate, getStartDate } from '../../shared/utils/time';
// import { VoiceModalDetailComponent } from '@shared/components/messages/voice/voice-modal-detail/voice-modal-detail.component';

@Component({
  selector: 'app-msgRecord-sendDetail-voice',
  templateUrl: './voice.component.html',
  styleUrls: ['./voice.component.less'],
})
export class SendDetailVoiceComponent implements OnInit {
  constructor(
    private http: _HttpClient,
    private modal: ModalHelper,
    private msgSrv: NzMessageService,
    private router: Router,
    private dialogService: DialogService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {}

  // 自定义组件名
  static NAME = 'icc-msg-sendDetail';

  hisSuffixOffset = '';
  q: any = {
    params: {
      sendResult: -1,
      packName: '',
      phone: '',
      moResult: -1,
      packId: '',
      shardTime: null,
      start: format(getStartDate(new Date(), 7), 'yyyy-MM-dd HH:mm:ss'),
      end: format(getEndDate(new Date(), 0), 'yyyy-MM-dd HH:mm:ss'),
      start2: format(getStartDate(new Date(), 7), 'yyyy-MM-dd HH:mm:ss'),
      end2: format(getEndDate(new Date(), 0), 'yyyy-MM-dd HH:mm:ss'),
      appTypeId: 31,
    },
  };

  expandForm = false;
  queryParams = {
    id: '0',
    isDetail: false,
    sentCount: 0,
    validTickets: 0,
    successCount: 0,
    failCount: 0,
    unknownCount: 0,
    moCount: 0,
    invalidTickets: 0,
    // cancelTickets: 0,
    shardTime: null,
  };

  url = URLS.voiceSendDetail.url;

  @ViewChild('st', { static: false }) st: STComponent;
  columns: STColumn[] = [
    {
      title: '批次名称',
      // index: 'batchName',
      render: 'tpl-batchName',
      fixed: 'left',
      width: 250,
      className: 'text-center',
    },
    {
      title: '姓名',
      // index: 'userName',
      render: 'tpl-userName',
      width: 112,
      className: 'text-center',
    },
    {
      title: '所属分组',
      index: 'userGroups',
      render: 'userGroupsStr',
      width: 132,
      className: 'text-center',
    },
    {
      title: '号码',
      index: 'terminalId',
      width: 140,
      className: 'text-center',
    },
    {
      title: '发送内容',
      index: 'displayContent',
      type: 'link',
      width: 200,
      className: 'text-center',
      click: (item, instance) => {
        const VoiceModalDetailComponent =
          this.messageService.getModalDetailComponent(
            this.messageService.getMsgTypeByName('voice', true)
          );
        if (VoiceModalDetailComponent) {
          this.modal
            .createStatic(VoiceModalDetailComponent, {
              mtContent: item.content,
            })
            .subscribe(() => {});
        }
      },
    },
    {
      title: '发送策略',
      index: 'sendStrategyDTO.name',
      type: 'link',
      click: (item, instance) => {
        this.previewStrategyDetail(item);
      },
      width: 140,
      className: 'text-center',
    },
    {
      title: '核验结果',
      index: 'bizFormState',
      type: 'badge',
      badge: {
        true: { text: '核验成功', color: 'success' },
        false: { text: '核验失败', color: 'error' },
      },
      width: 110,
      className: 'text-center',
    },
    {
      title: '核验报告',
      index: 'bizFormStr',
      width: 172,
      className: 'text-center',
    },
    {
      title: '提交结果',
      index: 'ticketState',
      type: 'badge',
      badge: {
        1: { text: '等待提交', color: 'processing' },
        2: { text: '提交成功', color: 'success' },
        3: { text: '取消提交', color: 'default' },
        4: { text: '提交失败', color: 'error' },
      },
      width: 110,
      className: 'text-center',
    },
    {
      title: '提交失败原因',
      // index: 'submitOriginResultStr',
      render: 'tpl-submitOriginResultStr',
      width: 130,
      className: 'text-center',
    },
    {
      title: '发送结果',
      index: 'result',
      type: 'badge',
      badge: {
        1: { text: '成功', color: 'success' },
        2: { text: '失败', color: 'error' },
        3: { text: '未知', color: 'default' },
      },
      width: 100,
      className: 'text-center',
    },
    {
      title: '状态报告',
      index: 'sendResult',
      width: 200,
      className: 'text-center',
    },
    {
      title: '呼叫时长',
      index: 'callDuration',
      width: 100,
      className: 'text-center',
    },
    {
      title: '通话时长',
      index: 'answerDuration',
      width: 100,
      className: 'text-center',
    },
    {
      title: '上行情况',
      index: 'hasMo',
      type: 'badge',
      badge: {
        true: { text: '已上行', color: 'success' },
        false: { text: '未上行', color: 'error' },
      },
      width: 100,
      className: 'text-center',
    },
    {
      title: '串行补发',
      index: 'resend',
      type: 'tag',
      tag: {
        false: { text: '否', color: 'green' },
        true: { text: '是', color: 'green' },
      },
      width: 100,
      className: 'text-center',
    },
    {
      title: '渠道号',
      index: 'actualChannelName',
      width: 100,
      className: 'text-center',
    },
    {
      title: '发送账号',
      // index: 'account',
      render: 'tpl-account',
      width: 152,
      className: 'text-center',
    },
    {
      title: '接收时间',
      index: 'postTime',
      type: 'date',
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      width: 200,
      className: 'text-center',
    },
    {
      title: '提交时间',
      index: 'submitTime',
      type: 'date',
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      width: 200,
      className: 'text-center',
    },
    {
      title: '拨打时间',
      index: 'doneTime',
      type: 'date',
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      width: 200,
      className: 'text-center',
    },
    {
      title: '接听时间',
      index: 'answerTime',
      type: 'date',
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      width: 200,
      className: 'text-center',
    },
  ];

  res: STRes = {
    process: (data, rawData) => {
      if (rawData.extparams && rawData.extparams.hisSuffixOffset) {
        this.hisSuffixOffset = rawData.extparams.hisSuffixOffset;
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].content && data[i].content.length > 10) {
          data[i].displayContent = data[i].content.substring(0, 10) + '...';
        } else {
          data[i].displayContent = data[i].content;
        }
      }
      return data;
    },
  };

  req: STReq = {
    method: 'POST',
    allInBody: true,
    body: this.q,
    process: (requestOptions: STRequestOptions) => {
      requestOptions.body.params.hisSuffixOffset = this.hisSuffixOffset;
      return requestOptions;
    },
  };

  // 选中的数据
  selectedRows: STData[] = [];
  isOpenExport = false;
  isOpenContentDetail = false;
  // 当前查看详情的模板
  currentTemplate: any = {};

  detailItem = {
    isMo: false,
    msgType: null,
    content: '',
  };

  /* 发送策略 */
  isOpenSendStrategy = false;
  // 当前查看策略详情
  strategyDetail: any = {};
  // 策略发送方式(如有相同意义字段，请替换)
  strategySend = [
    {
      name: '并行（同时发送）',
      type: 2,
    },
    {
      name: '串行（按优先级）',
      type: 1,
    },
  ];
  // 逻辑关系(如有相同意义字段，请替换)
  relationTypes = {
    1: '"与"关系',
    2: '"或"关系',
  };

  /*searchOptions*/
  searchOptions: any = {
    appTypeId: 31,
    channelNumber: '',
    account: '',
    bizFormStates: {
      bizFormState: -1,
      list: [
        { label: '全部', value: -1 },
        { label: '核验成功', value: 1 },
        { label: '核验失败', value: 2 },
      ],
    },
    sendResults: {
      sendResult: -1,
      list: [
        { label: '全部', value: -1 },
        { label: '成功', value: 1 },
        { label: '失败', value: 2 },
        { label: '未知', value: 3 },
      ],
    },
    packName: '',
    phone: '',
    moResults: {
      moResult: -1,
      list: [
        { label: '全部', value: -1 },
        { label: '已上行', value: 1 },
        { label: '未上行', value: 2 },
      ],
    },
    dateRange: [getStartDate(new Date(), 7), getEndDate(new Date(), 0)],
    // datePostRange: [getStartDate(new Date(), 7), getEndDate(new Date(), 0)],
  };

  // 等待导出的文件路径列表
  waitingExportFiles: any = [];
  // 存放时间，用于过期
  waitingExportFilesMap: { [key: string]: Date } = {};
  downloadPath = URLS.attachment.url + '?module=11&attach=2&path=';
  // 过期时间 10分钟
  expiredTime = 10 * 60 * 60 * 1000;

  multiLineDisplay(list, rows) {
    let resultStr = '';
    let br = '<br />';
    if (list && list instanceof Array) {
      for (let i = 0; i < list.length; i++) {
        if (rows <= 0) {
          resultStr += list[i].name + br;
        } else if (i < rows) {
          resultStr += list[i].name + br;
        } else {
          resultStr = resultStr.slice(0, resultStr.length - br.length) + '...';
          break;
        }
      }
      if (rows <= 0 || list.length <= rows) {
        resultStr = resultStr.slice(0, resultStr.length - br.length);
      }
    }
    return resultStr;
  }

  _handleClose() {
    this.isOpenContentDetail = false;
  }
  closeStrageModal() {
    this.isOpenSendStrategy = false;
  }

  // 策略详情
  previewStrategyDetail(item: any) {
    this.strategyDetail = item.sendStrategyDTO;
    if (this.strategyDetail.conditions instanceof Array) {
      this.strategyDetail.conditions.forEach((item) => {
        if (!item.bindObj) {
          item.bindObj = item.object;
        }
      });
    }
    this.strategyDetail.msgTypeList = [];
    const arr = this.strategyDetail.msgTypes.split(',');
    arr.forEach((str) => {
      let o = this.messageService.getMsgList().find((obj) => obj.type == +str);
      this.strategyDetail.msgTypeList.push(o);
    });
    this.isOpenSendStrategy = true;
  }

  /* 发送策略 */
  stChange(e: STChange) {
    switch (e.type) {
      case 'checkbox':
        this.selectedRows = e.checkbox;
        break;
    }
  }

  ngOnInit() {
    this.detailItem = {
      isMo: false,
      msgType: this.messageService.getMsgTypeByName('voice', true),
      content: '',
    };
    // 获取参数， 使用 queryParams
    this.queryParams.id = this.route.snapshot.queryParams.id || '';
    this.queryParams.isDetail =
      this.route.snapshot.queryParams.isDetail || false;
    this.q.params.packId = this.queryParams.id;
    this.queryParams.shardTime =
      new Date(this.route.snapshot.queryParams.shardTime) || new Date();
    this.q.params.shardTime = this.queryParams.shardTime;
    let start = new Date(
      this.queryParams.shardTime.getTime() - 24 * 60 * 60 * 1000
    ); // 前一天
    let end = new Date(
      this.queryParams.shardTime.getTime() + 24 * 60 * 60 * 1000
    ); // 后一天
    let start2 = new Date(
      this.queryParams.shardTime.getTime() - 24 * 60 * 60 * 1000
    ); // 前一天
    let end2 = new Date(
      this.queryParams.shardTime.getTime() + 24 * 60 * 60 * 1000
    ); // 后一天
    if (this.queryParams.isDetail) {
      // this.q.params.sendResult = 2;
      // this.searchOptions.sendResults.sendResult = 2;
      this.q.params.start = format(
        getStartDate(start, 0),
        'yyyy-MM-dd HH:mm:ss'
      );
      this.q.params.end = format(getEndDate(end, 0), 'yyyy-MM-dd HH:mm:ss');
      this.searchOptions.dateRange = [
        getStartDate(start, 0),
        getEndDate(end, 0),
      ];
      this.q.params.start2 = format(
        getStartDate(start2, 0),
        'yyyy-MM-dd HH:mm:ss'
      );
      this.q.params.end2 = format(getEndDate(end2, 0), 'yyyy-MM-dd HH:mm:ss');
      // this.searchOptions.datePostRange = [getStartDate(start2, 0), getEndDate(end2, 0)];
      this.url = URLS.voiceSendRecordDetail.url;
      this.columns = [
        { title: '号码', index: 'terminalId', width: 120 },
        { title: '姓名', index: 'userName', width: 80 },
        {
          title: '所属分组',
          index: 'userGroups',
          render: 'userGroupsStr',
          width: 100,
        },
        {
          title: '发送内容',
          index: 'content',
          type: 'link',
          width: 120,
          click: (item, instance) => {
            this.detailItem.content = item.content;
            // this.currentTemplate = item;
            this.isOpenContentDetail = true;
          },
        },
        {
          title: '发送策略',
          index: 'sendStrategyDTO.name',
          type: 'link',
          click: (item, instance) => {
            this.previewStrategyDetail(item);
          },
          width: 140,
        },
        {
          title: '核验结果',
          index: 'bizFormState',
          type: 'badge',
          badge: {
            true: { text: '核验成功', color: 'success' },
            false: { text: '核验失败', color: 'error' },
          },
          width: 110,
        },
        {
          title: '核验报告',
          index: 'bizFormStr',
          width: 172,
        },
        {
          title: '提交结果',
          index: 'ticketState',
          type: 'badge',
          badge: {
            1: { text: '等待提交', color: 'processing' },
            2: { text: '提交成功', color: 'success' },
            3: { text: '取消提交', color: 'default' },
            4: { text: '提交失败', color: 'error' },
          },
          width: 110,
        },
        { title: '提交失败原因', index: 'submitOriginResultStr', width: 120 },
        { title: '状态报告', index: 'sendResult', width: 100 },
        {
          title: '发送结果',
          index: 'result',
          type: 'badge',
          badge: {
            1: { text: '成功', color: 'success' },
            2: { text: '失败', color: 'error' },
            3: { text: '未知', color: 'default' },
          },
          width: 100,
        },
        {
          title: '拨打时间',
          index: 'submitTime',
          type: 'date',
          dateFormat: 'yyyy-MM-dd HH:mm:ss',
          width: 170,
        },
        { title: '呼叫时长', index: 'callDuration', width: 100 },
        {
          title: '接听时间',
          index: 'answerTime',
          type: 'date',
          dateFormat: 'yyyy-MM-dd HH:mm:ss',
          width: 170,
        },
        { title: '接听时长', index: 'answerDuration', width: 100 },
        {
          title: '上行情况',
          index: 'hasMo',
          type: 'badge',
          badge: {
            true: { text: '已上行', color: 'success' },
            false: { text: '未上行', color: 'error' },
          },
          width: 100,
        },
        {
          title: '串行补发',
          index: 'resend',
          type: 'tag',
          tag: {
            false: { text: '否', color: 'green' },
            true: { text: '是', color: 'green' },
          },
          width: 100,
        },
        { title: '通道号', index: 'actualChannelName', width: 100 },
      ];
    }
    this.queryStatistical();
  }

  queryStatistical() {
    // 查询统计数据
    if (this.queryParams.isDetail) {
      this.http
        .post(URLS.sendRecordDetail.url, {
          packId: this.q.params.packId,
          start:
            this.searchOptions.dateRange.length >= 1
              ? format(this.searchOptions.dateRange[0], 'yyyy-MM-dd HH:mm:ss')
              : null,
          end:
            this.searchOptions.dateRange.length >= 2
              ? format(this.searchOptions.dateRange[1], 'yyyy-MM-dd HH:mm:ss')
              : null,
          // start2: this.searchOptions.datePostRange.length >= 1 ? format(this.searchOptions.datePostRange[0], 'yyyy-MM-dd HH:mm:ss') : null,
          // end2: this.searchOptions.datePostRange.length >= 2 ? format(this.searchOptions.datePostRange[1], 'yyyy-MM-dd HH:mm:ss') : null,
        })
        .subscribe((res) => {
          if (res.status === 0) {
            res.data.forEach((value) => {
              if (value.msgType == 3) {
                this.queryParams.sentCount = value.msgCount || 0;
                this.queryParams.validTickets = value.validTickets || 0;
                this.queryParams.successCount = value.successCount || 0;
                this.queryParams.failCount = value.failureCount || 0;
                this.queryParams.unknownCount = value.unknownNum || 0;
                this.queryParams.moCount = value.moCount || 0;
                this.queryParams.invalidTickets = value.invalidTickets || 0;
                // this.queryParams.cancelTickets = value.cancelTickets || 0;
              }
            });
          }
        });
    }
  }

  getTableList() {
    this.hisSuffixOffset = '';
    this.st.reset({
      params: {
        hisSuffixOffset: this.hisSuffixOffset,
        packId: this.q.params.packId,
        shardTime: this.q.params.shardTime,
        sendResult: this.searchOptions.sendResults.sendResult,
        bizFormState: this.searchOptions.bizFormStates.bizFormState,
        channelNumber: this.searchOptions.channelNumber,
        account: this.searchOptions.account,
        packName: this.searchOptions.packName,
        phone: this.searchOptions.phone,
        moResult: this.searchOptions.moResults.moResult,
        appTypeId: this.searchOptions.appTypeId,
        start:
          this.searchOptions.dateRange.length >= 1
            ? format(this.searchOptions.dateRange[0], 'yyyy-MM-dd HH:mm:ss')
            : null,
        end:
          this.searchOptions.dateRange.length >= 2
            ? format(this.searchOptions.dateRange[1], 'yyyy-MM-dd HH:mm:ss')
            : null,
        // start2: this.searchOptions.datePostRange.length >= 1 ? format(this.searchOptions.datePostRange[0], 'yyyy-MM-dd HH:mm:ss') : null,
        // end2: this.searchOptions.datePostRange.length >= 2 ? format(this.searchOptions.datePostRange[1], 'yyyy-MM-dd HH:mm:ss') : null,
      },
    });
    this.queryStatistical();
  }

  resetTableList() {
    // 重置搜索条件
    this.hisSuffixOffset = '';
    if (this.queryParams.isDetail) {
      this.searchOptions.sendResults.sendResult =
        this.searchOptions.sendResults.list[0].value;
    } else {
      this.searchOptions.sendResults.sendResult =
        this.searchOptions.sendResults.list[0].value;
    }
    this.searchOptions.bizFormStates.bizFormState = -1;
    this.searchOptions.packName = '';
    this.searchOptions.phone = '';
    this.searchOptions.channelNumber = '';
    this.searchOptions.account = '';
    this.searchOptions.moResults.moResult =
      this.searchOptions.moResults.list[0].value;
    if (this.queryParams.isDetail) {
      let start = new Date(
        this.queryParams.shardTime.getTime() - 24 * 60 * 60 * 1000
      ); // 前一天
      let end = new Date(
        this.queryParams.shardTime.getTime() + 24 * 60 * 60 * 1000
      ); // 后一天
      this.searchOptions.dateRange = [
        getStartDate(start, 0),
        getEndDate(end, 0),
      ];
      // this.searchOptions.datePostRange = [getStartDate(start, 0), getEndDate(end, 0)];
    } else {
      this.searchOptions.dateRange = [
        getStartDate(new Date(), 7),
        getEndDate(new Date(), 0),
      ];
      // this.searchOptions.datePostRange = [getStartDate(new Date(), 7), getEndDate(new Date(), 0)];
    } // 重新加载table数据
    this.getTableList();
  }

  goExport() {
    this.router.navigateByUrl('/system/import-export/export');
  }

  closeExport() {
    this.isOpenExport = false;
  }
  export() {
    // 判断前端表格是否有数据，如果没有，则直接返回“无数据可导出”
    if (!this.st._data || this.st._data.length === 0) {
      this.dialogService.notification.warning('导出', '无数据可导出');
      return;
    }
    this.http
      .post(URLS.voiceSendDetailExport.url, {
        params: {
          hisSuffixOffset: '',
          packId: this.q.params.packId,
          shardTime: this.q.params.shardTime,
          sendResult: this.searchOptions.sendResults.sendResult,
          bizFormState: this.searchOptions.bizFormStates.bizFormState,
          channelNumber: this.searchOptions.channelNumber,
          account: this.searchOptions.account,
          packName: this.searchOptions.packName,
          phone: this.searchOptions.phone,
          moResult: this.searchOptions.moResults.moResult,
          appTypeId: this.searchOptions.appTypeId,
          start:
            this.searchOptions.dateRange.length >= 1
              ? format(this.searchOptions.dateRange[0], 'yyyy-MM-dd HH:mm:ss')
              : null,
          end:
            this.searchOptions.dateRange.length >= 2
              ? format(this.searchOptions.dateRange[1], 'yyyy-MM-dd HH:mm:ss')
              : null,
          // start2: this.searchOptions.datePostRange.length >= 1 ? format(this.searchOptions.datePostRange[0], 'yyyy-MM-dd HH:mm:ss') : null,
          // end2: this.searchOptions.datePostRange.length >= 2 ? format(this.searchOptions.datePostRange[1], 'yyyy-MM-dd HH:mm:ss') : null,
        },
      })
      .subscribe((res) => {
        if (res.status === 0) {
          this.isOpenExport = true;
        } else {
          this.dialogService.notification.error('导出', res.errorMsg);
        }
      });
  }
  // 设置开始时间为00:00:00 结束时间为23:59:59
  onOkDate() {
    // if (this.searchOptions.datePostRange[0]) {
    //   // 设置开始时间为选择日期的 00:00:00
    //   this.searchOptions.datePostRange[0] = new Date(new Date(new Date(this.searchOptions.datePostRange[0]).toLocaleDateString()).getTime());
    // }
    // if (this.searchOptions.datePostRange[1]) {
    //   // 设置开始时间为选择日期的 23:59:59
    //   this.searchOptions.datePostRange[1] = new Date(new Date(new Date(this.searchOptions.datePostRange[1]).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
    // }
  }

  // 设置开始时间为00:00:00 结束时间为23:59:59
  onOkCallDate() {
    if (this.searchOptions.dateRange[0]) {
      // 设置开始时间为选择日期的 00:00:00
      this.searchOptions.dateRange[0] = new Date(
        new Date(
          new Date(this.searchOptions.dateRange[0]).toLocaleDateString()
        ).getTime()
      );
    }
    if (this.searchOptions.dateRange[1]) {
      // 设置开始时间为选择日期的 23:59:59
      this.searchOptions.dateRange[1] = new Date(
        new Date(
          new Date(this.searchOptions.dateRange[1]).toLocaleDateString()
        ).getTime() +
          24 * 60 * 60 * 1000 -
          1
      );
    }
  }
}
